module.exports = __webpack_public_path__ + "static/media/raycast_banner_100.bbf953c8.png";